import selectComponent from './Selector'

const selector = {
  install: function(Vue) {
    Vue.component(selectComponent.name, selectComponent);
  }
};

export default selector;



// WEBPACK FOOTER //
// ./src/plugin/index.js